import React from "react";
import { Link, useNavigate } from "react-router-dom";

const LakshmiHome = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f5f5f0] text-black relative">
      <button
        onClick={() => navigate(-1)}
        className="fixed top-6 left-6 z-50 flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md border border-black/10 rounded-full text-black hover:bg-black hover:text-white transition-all duration-300 shadow-sm"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back
      </button>
      <h1 className="text-4xl md:text-6xl font-bold mb-4">Lakshmi Praba</h1>
      <p className="text-xl text-gray-600 mb-8">View Home page image and contents will be provided later.</p>
      <Link to="/" className="px-6 py-3 bg-black text-white rounded-full font-semibold">
        Return to Portfolio
      </Link>
    </div>
  );
};

export default LakshmiHome;
